import { render } from "./doctor-pendingblog.vue?vue&type=template&id=4ccbd964"
import script from "./doctor-pendingblog.vue?vue&type=script&lang=js"
export * from "./doctor-pendingblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__